// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"12":"e96b851c","92":"e2bb1962","99":"b4c415f7","215":"aadd0f10","337":"cd5e0db8","443":"14d249b2","479":"4d3566ac","531":"1a1465e8","952":"4bba68cb"}[chunkId] + ".chunk.js";
};